var ProvadorStorage = {
  version: 'FIT_PROFILE_V3',
  expirationDays: 90,

  saveProfile: function(profileData) {
    const dataToSave = {
      version: this.version,
      timestamp: new Date().getTime(),
      data: profileData
    };
    localStorage.setItem('provadorVirtualProfile', JSON.stringify(dataToSave));
  },

  getProfile: function() {
    const rawData = localStorage.getItem('provadorVirtualProfile');
    if (!rawData) return null;

    try {
      const parsedData = JSON.parse(rawData);
      
      // Check version
      if (parsedData.version !== this.version) {
        this.clearProfile();
        return null;
      }

      // Check expiration
      const now = new Date().getTime();
      const expirationMs = this.expirationDays * 24 * 60 * 60 * 1000;
      if (now - parsedData.timestamp > expirationMs) {
        this.clearProfile();
        return null;
      }

      return parsedData.data;
    } catch (e) {
      this.clearProfile();
      return null;
    }
  },

  clearProfile: function() {
    localStorage.removeItem('provadorVirtualProfile');
  }
};

window.ProvadorStorage = ProvadorStorage;
